export const EMBEDDED_MODE_QUERY_PARAM = "embedded";
export const EMBEDDED_MODE_MOBILE = "mobile";

const EMBEDDED_MODE_STORAGE_KEY = "mela.embeddedMode";

const readStoredEmbeddedMode = (): string | null => {
  try {
    return window.sessionStorage.getItem(EMBEDDED_MODE_STORAGE_KEY);
  } catch {
    return null;
  }
};

const storeEmbeddedMode = (mode: string) => {
  try {
    window.sessionStorage.setItem(EMBEDDED_MODE_STORAGE_KEY, mode);
  } catch {
    // Storage can be unavailable in a locked-down WebView; the query
    // parameter still drives the current page.
  }
};

export const isEmbeddedMode = (
  search: string = window.location.search,
): boolean => {
  const requestedMode = new URLSearchParams(search).get(
    EMBEDDED_MODE_QUERY_PARAM,
  );

  if (requestedMode === EMBEDDED_MODE_MOBILE) {
    storeEmbeddedMode(requestedMode);
    return true;
  }

  return readStoredEmbeddedMode() === EMBEDDED_MODE_MOBILE;
};
